import React from 'react';
// import JourneySlider from "../Package/JourneySlider"


function IframeComponent() {
  return (
    <>
      {/* Add the iframe here */}
      <iframe
        // src={JourneySlider}
        src="./swipe.html"
        width="100%"
        height="600px"
        style={{ borderRadius: '0px', border: 'none' }}
        title="Embedded Content"
      />
    </>
  )
}

export default IframeComponent